'use strict';

var chunkSNEGV6DE_js = require('./chunk-SNEGV6DE.js');
var chunkHPRUU6IH_js = require('./chunk-HPRUU6IH.js');
var chunk7GTRMEIW_js = require('./chunk-7GTRMEIW.js');
var chunkVNK76C2V_js = require('./chunk-VNK76C2V.js');
var chunkOXXOHGTT_js = require('./chunk-OXXOHGTT.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var r = require('react');
var c = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var r__default = /*#__PURE__*/_interopDefault(r);
var c__default = /*#__PURE__*/_interopDefault(c);

var L=c__default.default.div`
  border-radius: ${({$borderRadius:o})=>o};
  background-color: ${({$variantConfig:o})=>o.bgColor};
  box-shadow: ${({$shadow:o,$variantConfig:n})=>o?n.shadow:"none"};
  ${chunkSNEGV6DE_js.a} & {
    border-bottom: ${({$shadow:o,$variantConfig:n})=>o?"none":`1px solid ${n.accordionItemBorderColor}`};
  }
`,k=c__default.default.div`
  display: flex;
  padding: ${({$padding:o})=>o};
  align-items: center;
  user-select: none;
  padding-bottom: ${({$isOpen:o,$sizeConfig:n})=>!o&&n.headerPaddingBottom};
  > svg {
    &:first-child {
      margin-right: 8px;
      flex-shrink: 0;
    }

    &:last-child {
      padding: 1px;
      transition: all 0.2s ease-in-out;
      flex-shrink: 0;
    }
  }
`,w=c__default.default.div`
  margin-top: ${({$sizeConfig:o})=>o.marginTop};
  padding: ${({$padding:o})=>o};
  width: initial;
  margin-left: ${({$variantConfig:o})=>o.contentMarginLeft};
  margin-right: ${({$variantConfig:o})=>o.contentMarginRight};
  color: ${({$color:o})=>o};
`,B=c__default.default.div`
  flex-grow: 1;
  margin-left: ${({$variantConfig:o})=>o.headerMarginLeft};
`,D=({titleType:o="label",variant:n="primary",title:s="Label",size:t="regular",children:h="",onChange:b=()=>{},shadow:g=!0,isOpen:i=!1,icon:a=null})=>{let{tokens:p}=chunkHUKGHOBJ_js.b(),{variants:e}=chunkOXXOHGTT_js.a(p),[d,f]=r.useState(i),l=g||e[n].isShadow,P=r.useCallback(()=>{f(m=>(b(!m),!m));},[]);return r.useEffect(()=>{i!==d&&f(i);},[i]),r__default.default.createElement(L,{$shadow:g,$variantConfig:e[n],$borderRadius:l?e[n].cornerRadius:"unset"},r__default.default.createElement(k,{$sizeConfig:e[n][t],$padding:l?e[n][t].padding:e[n][t].flatPadding,$isOpen:d,onClick:P},typeof a=="function"?a(e[n].iconColor):a,r__default.default.createElement(B,{$variantConfig:e[n]},o===chunkOXXOHGTT_js.c.LABEL?r__default.default.createElement(chunkVNK76C2V_js.a,{fontWeight:"medium",level:3,color:p.text_default_text_primary},s):r__default.default.createElement(chunkHPRUU6IH_js.a,{level:3},s)),r__default.default.createElement(chunk7GTRMEIW_js.a,{rotateBy:d?180:0})),d&&r__default.default.createElement(w,{$sizeConfig:e[n][t],$variantConfig:e[n],$color:e[n].color,$padding:l?e[n][t].contentPadding:e[n][t].flatContentPadding},h))};

exports.a = L;
exports.b = D;
